import React, {Component} from "react";
import {downloadAnnotations} from "../utils/annotations_app_utils";
import {DownloadOutlined} from "@mui/icons-material";
import {morphleBaseTheme1} from "../themes";
import {IconButton, MenuItem, Popover} from "@mui/material";
import { aclPermissions, hasPermissions } from "const/ACLPermissions";
import cookie from "react-cookies";

class AnnotationsDownload extends Component {

	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null,
		}
		this.disabled = !hasPermissions([aclPermissions.view_own_annotation])
	}
	
	render() {
		return <>
			<IconButton
				sx={{ padding: "inherit" }}
				onClick={e => this.setState({ anchorEl: e.currentTarget })}
			>
				<DownloadOutlined sx={{color: morphleBaseTheme1.palette.headBarIcon.primary}}/>
			</IconButton>
			<Popover open={this.state.anchorEl} anchorEl={this.state.anchorEl}
			         onClose={() => this.setState({anchorEl: null,})}
			         anchorOrigin={{vertical: 'bottom', horizontal: 'left',}}>
				<MenuItem disabled={this.disabled} onClick={() =>
					downloadAnnotations(this.props.slideId, this.props.annoDrawer, 'json')}>
					Json
				</MenuItem>
				<MenuItem disabled={this.disabled} onClick={() =>
					downloadAnnotations(this.props.slideId, this.props.annoDrawer, 'csv')}>
					CSV
				</MenuItem>
				<MenuItem disabled={this.disabled} onClick={() =>
					downloadAnnotations(this.props.slideId, this.props.annoDrawer, 'geojson')}>
					QuPath
				</MenuItem>
			</Popover>
		</>
	}
}

export default AnnotationsDownload;
